import React from 'react';
import Form, { Field, Submit } from '../../components/Form';
import Modal, { ModalActionFooter, ModalTitle } from '../../components/Modal';
import request from '../../utils/network/request';

const SUBDOMAIN_REGEX = /^\w[\w-]+\w$/;

interface ZendeskEnableModalProps {
  close: () => void;
  redirectUrl: string | null;
}

const ZendeskEnableModal = ({
  close,
  redirectUrl,
}: ZendeskEnableModalProps) => {
  const handleSubmit = async ({ host }: { host: string }) => {
    const params = { host: `${host}.zendesk.com`, redirect_url: redirectUrl };

    const data = await request('/api/zendesk/integrate', 'GET', params);
    document.location = (data as { url: string }).url;
  };

  return (
    <Modal width={425}>
      <ModalTitle close={close}>Enable Zendesk</ModalTitle>

      <Form<{ host: string }>
        initialValues={{ host: '' }}
        onSubmit={handleSubmit}
        validate={({ host }) =>
          SUBDOMAIN_REGEX.test(host) ? {} : { host: 'Enter a valid subdomain' }
        }
      >
        <Field
          name="host"
          label="Enter your Zendesk subdomain:"
          placeholder="subdomain"
          prepend="https://"
          append=".zendesk.com"
          required
        />

        <ModalActionFooter primary={<Submit>Authorize Zendesk</Submit>} />
      </Form>
    </Modal>
  );
};

export default ZendeskEnableModal;
